import EventBus from "../event-bus";
const friendDeleteHook = new EventBus<string>("friendDeleteHook");

export default friendDeleteHook;
